import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PhoneCall, MessageSquare } from "lucide-react";

export default function FloatingCTA() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ type: "spring", damping: 22, stiffness: 200 }}
          className="fixed bottom-5 inset-x-0 z-[60] flex justify-center px-5"
          data-testid="floating-cta"
        >
          <div className="glass rounded-full p-1.5 flex items-center gap-1.5 shadow-2xl shadow-black/50">
            <a
              href="tel:7011364764"
              data-testid="floating-call-button"
              className="flex items-center gap-2 bg-cyan-500 hover:bg-cyan-400 text-on-accent font-display font-bold text-sm px-5 py-3 rounded-full transition-colors duration-300"
            >
              <PhoneCall className="w-4 h-4" /> Call Now
            </a>
            <a
              href="https://wa.me/917011364764?text=Hi%20Anaya%20CCTV%2C%20I%20need%20a%20security%20quote"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-float-button"
              className="flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-on-accent font-display font-bold text-sm px-5 py-3 rounded-full transition-colors duration-300"
            >
              <MessageSquare className="w-4 h-4" /> WhatsApp
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
